/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Toast_Zip_DownloadedInputs */



/**
* | output |
* | --- |
* | "Downloaded {count} files as zip" |
*
* @param {Spaces_Toast_Zip_DownloadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_zip_downloaded = /** @type {((inputs: Spaces_Toast_Zip_DownloadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Zip_DownloadedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Dateien als ZIP heruntergeladen`)
	return /** @type {LocalizedString} */ (`Downloaded ${i?.count} files as zip`)
});